
import { defineComponent, PropType, ref } from 'vue'
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';import QForm from 'quasar/src/components/form/QForm.js';
import BillingTemplatesFormFieldStreet from '@/components/billing-templates/form-fields/street.vue'
import BillingTemplatesFormFieldCity from '@/components/billing-templates/form-fields/city.vue'
import BillingTemplatesFormFieldZip from '@/components/billing-templates/form-fields/zip.vue'
import BillingTemplatesFormFieldCountry from '@/components/billing-templates/form-fields/country.vue'

import { Address, useBillingTemplateModule } from '@/modules/billing-templates'
import { useFormModule } from '@/modules/_shared/forms'

export default defineComponent({
    name: 'billing-templates-edit-address-dialog',
    components: {
        BillingTemplatesFormFieldStreet,
        BillingTemplatesFormFieldCity,
        BillingTemplatesFormFieldZip,
        BillingTemplatesFormFieldCountry
    },
    props: {
        address: {
            type: Object as PropType<Address>,
            required: true
        },
        organizationId: {
            type: String,
            required: true
        },
        billingTemplateId: {
            type: String,
            required: true
        },
        updateCallback: {
            type: Function as PropType<(t: Address) => void>,
            required: true
        }
    },
    setup (props) {
        const { dialogRef, onDialogHide, onDialogOK, onDialogCancel } = useDialogPluginComponent()
        const { submitForm, createOnSuccess } = useFormModule()
        const { updateAddress } = useBillingTemplateModule()

        const form = ref<QForm>()
        const addressModel = ref(props.address)

        const sendRequest = async () => updateAddress(props.organizationId, props.billingTemplateId, {
            organizationId: props.organizationId,
            billingTemplateId: props.billingTemplateId,
            street: addressModel.value.street,
            city: addressModel.value.city,
            zip: addressModel.value.zip,
            countryCode: addressModel.value.countryCode
        })

        const onSubmit = () => submitForm(
            form.value,
            sendRequest,
            createOnSuccess('Address changed')
        ).then(() => {
            onDialogOK()
            props.updateCallback(addressModel.value)
        })

        return {
            dialogRef,
            onDialogHide,
            onCancelClick: onDialogCancel,
            addressModel,
            onSubmit,
            form
        }
    }
})
